/**
 * Created by dx.yang on 2017/3/20.
 */


export const Version = '2016-03-04';
export const Service = 'kec';
export const KecPath = '/kecapi/';
export const noLoginKecApi = '/noLoginKecApi/';
// export const KecPath = '/console-kec-api/';
export const source = 'kec';
export const commonUrls = {
    createProductCallback: '//network.' + KSC_SECNET_CONSOLE.BASE_HOST + '/index.html#!/',
    createProductVerify: '//uc.' + KSC_SECNET_CONSOLE.BASE_HOST + '/pro/buy/#/order/verify?'
};
